var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCenterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.62438H10.5V3.98938C10.5 3.67937 10.36 3.38937 10.115 3.19937L9.5 2.71938L9.49 1.49437C9.49 1.21937 9.265 0.999375 8.99 0.999375H7.285L6.615 0.479375C6.255 0.194375 5.745 0.194375 5.385 0.479375L1.885 3.19937C1.64 3.38937 1.5 3.67938 1.5 3.98438L1.475 9.62438H1C0.795 9.62438 0.625 9.79438 0.625 9.99938C0.625 10.2044 0.795 10.3744 1 10.3744H11C11.205 10.3744 11.375 10.2044 11.375 9.99938C11.375 9.79438 11.205 9.62438 11 9.62438ZM3.25 5.37438V4.62438C3.25 4.34938 3.475 4.12438 3.75 4.12438H4.75C5.025 4.12438 5.25 4.34938 5.25 4.62438V5.37438C5.25 5.64938 5.025 5.87438 4.75 5.87438H3.75C3.475 5.87438 3.25 5.64938 3.25 5.37438ZM7.25 9.62438H4.75V8.24938C4.75 7.83438 5.085 7.49938 5.5 7.49938H6.5C6.915 7.49938 7.25 7.83438 7.25 8.24938V9.62438ZM8.75 5.37438C8.75 5.64938 8.525 5.87438 8.25 5.87438H7.25C6.975 5.87438 6.75 5.64938 6.75 5.37438V4.62438C6.75 4.34938 6.975 4.12438 7.25 4.12438H8.25C8.525 4.12438 8.75 4.34938 8.75 4.62438V5.37438Z",
    fill: "#364A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterIcon);
export default __webpack_public_path__ + "static/media/centerIcon.6d578cd3add28098c3c78a5973ef4987.svg";
export { ForwardRef as ReactComponent };